function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDetail, withdraw } from '@/api/approval';
import { productDetailApi } from '@/api/product';
import Cookies from 'js-cookie';
export default {
  name: 'ApprovalDetail',
  data: function data() {
    return {
      id: null,
      instance: null,
      records: [],
      formFields: [],
      bizProduct: null,
      bizLoading: false,
      loading: false
    };
  },
  computed: {
    userId: function userId() {
      return Cookies.get('JavaAdminId_copy');
    },
    statusType: function statusType() {
      if (!this.instance) return 'info';
      if (this.instance.status === 0) return 'primary';
      if (this.instance.result === 0) return 'success';
      if (this.instance.result === 1) return 'danger';
      return 'info';
    },
    statusText: function statusText() {
      if (!this.instance) return '';
      if (this.instance.status === 0) return '审批中';
      if (this.instance.result === 0) return '已通过';
      if (this.instance.result === 1) return '已驳回';
      return '已撤回';
    },
    skuRows: function skuRows() {
      var list = this.bizProduct && this.bizProduct.attrValueList || [];
      return list.map(function (x) {
        return {
          sku: x.sku || '默认',
          price: x.price,
          otPrice: x.otPrice,
          stock: x.stock
        };
      });
    },
    rejectedComment: function rejectedComment() {
      return this.instance && this.instance.result === 1 ? this.instance.comment : '';
    }
  },
  created: function created() {
    this.id = +this.$route.params.id;
    this.load();
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return getDetail(this.id);
            case 2:
              res = _context.v;
              data = res && (res.data !== undefined ? res.data : res);
              this.instance = data && data.instance;
              this.records = data && data.records || [];
              this.formFields = data && data.formFields || [];
              this.loadBusiness();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error('加载失败: ' + (_t.message || _t));
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    /**
     * 按业务类型实时回查业务内容。
     * 快照(formFields)只有改造后新发起的审批才有，老审批全靠这里回查。
     */
    loadBusiness: function () {
      var _loadBusiness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var inst, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.bizProduct = null;
              inst = this.instance;
              if (!(!inst || !inst.businessId)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (String(inst.businessType || '').includes('商品')) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              this.bizLoading = true;
              _context2.p = 3;
              _context2.n = 4;
              return productDetailApi(inst.businessId);
            case 4:
              res = _context2.v;
              this.bizProduct = res && (res.data !== undefined ? res.data : res) || null;
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              // 商品被删或无权限时不弹错，走"未接入"提示即可
              this.bizProduct = null;
            case 6:
              _context2.p = 6;
              this.bizLoading = false;
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 5, 6, 7]]);
      }));
      function loadBusiness() {
        return _loadBusiness.apply(this, arguments);
      }
      return loadBusiness;
    }(),
    auditStatusText: function auditStatusText(status) {
      return {
        0: '无需审核',
        1: '待审核',
        2: '审核通过',
        3: '审核拒绝'
      }[status] || '—';
    },
    splitImages: function splitImages(value) {
      return String(value || '').split(',').map(function (x) {
        return x.trim();
      }).filter(Boolean);
    },
    isWide: function isWide(field) {
      if (field.type === 'image' || field.type === 'images') return true;
      return String(field.value || '').length > 30;
    },
    recType: function recType(result) {
      return {
        0: 'success',
        1: 'danger',
        2: 'warning',
        3: 'info'
      }[result] || 'info';
    },
    recActionText: function recActionText(rec) {
      var map = {
        SUBMIT: '提交申请',
        PASS: '通过',
        REJECT: '驳回',
        TRANSFER: '转办',
        WITHDRAW: '撤回',
        URGE: '催办'
      };
      return "".concat(rec.taskName || '', " \xB7 ").concat(map[rec.action] || rec.action);
    },
    withdrawInst: function () {
      var _withdrawInst = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.$confirm('确定撤回该申请?', '提示', {
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return withdraw(_this.id, _this.userId);
                    case 1:
                      _this.$message.success('已撤回');
                      _this.$router.push('/approval/myApproval');
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }))).catch(function () {});
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function withdrawInst() {
        return _withdrawInst.apply(this, arguments);
      }
      return withdrawInst;
    }(),
    editRejected: function editRejected() {
      var bizMap = {
        '商户新增商品': "/product/creatProduct/".concat(this.instance.businessId, "?editOrCopy=edit"),
        '商户修改商品': "/product/creatProduct/".concat(this.instance.businessId, "?editOrCopy=edit")
      };
      var path = bizMap[this.instance.businessType];
      if (path) this.$router.push(path);else this.$message.info('该业务类型暂不支持一键跳转');
    }
  }
};